'use client'

import { motion } from 'framer-motion'
import Link from 'next/link'
import Image from 'next/image'

export default function LazyPricingSection() {
  return (
    <div className="mx-auto max-w-[1920px] py-25">
      <div className="mx-auto max-w-7xl">
        {/* Premium System Section */}
        <div className="mb-16 grid grid-cols-1 gap-8 md:grid-cols-12">
          {/* Left Card */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            className="rounded-lg bg-[#ff4500] p-8 text-center text-white md:col-span-4 md:p-12"
          >
            <h3 className="mb-4 text-4xl font-bold">
              450 Wp <br className="block md:block" />
            </h3>
            <p className="text-lg">
              Hochwertige Glas-Glas-Module, Bifazial, Black Frame für Hohe Leistungsfähigkeit mit
              optimaler Stromerzeugung für maximale Effizienz
            </p>
          </motion.div>

          {/* Right Card */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="rounded-lg bg-[#e9e9e6] p-8 md:col-span-8 md:p-12"
          >
            <div className="px-4 md:px-0">
              <div className="grid grid-cols-1 gap-8 md:grid-cols-8">
                {/* Text Content */}
                <div className="text-center md:col-span-5 md:text-left">
                  <h2 className="mb-6 text-2xl font-bold text-gray-900 sm:text-3xl">
                    Unser Volks-<span className="text-[#ff4500]">Photovoltaik</span> Komplettsystem
                  </h2>
                  <p className="text-base leading-relaxed text-gray-600 sm:text-lg">
                    Unsere Photovoltaikkomplettsysteme bestehen jeweils aus Glas Glas Black Frame
                    Modulen mit <br className="hidden md:block" /> 450 Wp für eine optimale
                    Stromerzeugung, einem Lithium Eisenphosphat Speicher für die optimale Sicherheit
                    und eine hohe Autarkie und einem leistungsstarken Wechselrichter mit
                    App-Steuerung. Unsere Angebote beinhalten die Installation und die
                    Inbetriebnahme bundesweit.
                  </p>
                </div>

                {/* Image */}
                <div className="flex items-center justify-center md:col-span-3">
                  <div className="relative aspect-[3/4] w-full">
                    <Image
                      src="/images/full-instalation-3.webp"
                      alt="Premium Solar Panel"
                      fill
                      className="object-contain"
                      loading="lazy"
                      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 38vw, 25vw"
                    />
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* CTA Button */}
        <div className="mb-16 flex justify-center">
          <Link
            href="/termin"
            className="group relative rounded-lg bg-[#ff4500] px-8 py-4 font-bold text-white transition-all hover:bg-[#e03e00]"
          >
            Jetzt Angebot anfordern
          </Link>
        </div>
      </div>
    </div>
  )
}
